import { gsap, TweenLite, CSSPlugin } from "gsap/all"

gsap.registerPlugin(CSSPlugin)

export default class {
  constructor () {
    this.$searchMobileWrapper = document.querySelector('.search-bar__mobile-wrapper')
    this.$totoButton = document.querySelector('.search-bar__toto')
    this.$openButton = document.querySelector('.search-bar__open-button')
    this.$searchButton = document.querySelector('.search-bar__search-button')
    this.$closeButton = document.querySelector('.search-bar__close-button')
    this.$body = document.body
    this.$html = document.documentElement

    if (this.$searchMobileWrapper) {
      this.bindEvents()
    }
  }

  bindEvents () {
    this._boundSearchMobileAnimationHandler = this.searchMobileAnimationHandler.bind(this)

    this.$closeButton.addEventListener('click', this._boundSearchMobileAnimationHandler)
    this.$openButton.addEventListener('click', this._boundSearchMobileAnimationHandler)
    this.$searchButton.addEventListener('click', this._boundSearchMobileAnimationHandler)
  }

  destroy () {
    this.$closeButton.removeEventListener('click', this._boundSearchMobileAnimationHandler)
    this.$openButton.removeEventListener('click', this._boundSearchMobileAnimationHandler)
    this.$searchButton.removeEventListener('click', this._boundSearchMobileAnimationHandler)
  }

  searchMobileAnimationHandler (event) {
    this.slideAnimationUp(this.$searchMobileWrapper)
    this.slideAnimationUp(this.$searchButton)
    this.slideAnimationDown(this.$closeButton)
    this.$body.classList.toggle("overflow-hidden-body", !this.isOpen)
    this.$html.classList.toggle("overflow-hidden-html", !this.isOpen)
    this.isOpen = !this.isOpen
  }

  get isOpen () {
    return this.$body.dataset.isSearchOpen === "true"
  }

  set isOpen (val) {
    this.$body.dataset.isSearchOpen = val
  }

  slideAnimationUp (element) {
    TweenLite.to(element, 0.5, { y: this.isOpen ? '100%' : '0%' })
  }

  slideAnimationDown (element) {
    TweenLite.to(element, 0.5, { y: this.isOpen ? '-100%' : '0%' })
  }
}
